import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { ConvertSizeChartResponseData, DataResponse } from "schema"
import { z } from "zod"

export const FrontendConvertSizeChartSchema = z.object({
  document: z.instanceof(FileList).refine((value) => value.length > 0, { message: "Required" }),
})

export type ConvertSizeChartPayload = z.infer<typeof FrontendConvertSizeChartSchema>

type Response = DataResponse<z.infer<typeof ConvertSizeChartResponseData>>

export function useShopifyConvertSizeChartMutation() {
  return useMutation({
    mutationFn: async (data: ConvertSizeChartPayload) => {
      return axios
        .post<Response>(`/integrations/shopify/size-chart`, {
          file: data.document,
        })
        .then((response) => response.data.data)
    },
  })
}
